import { useContext } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Lead, NotificationType, Place } from 'shared/topchef.types';
import placesApi from 'shared/topchef-api-places';

import { NotificationContext } from 'shared/NotificationContext'
import LeadContent from 'pages/shared/lead-content/LeadContent'
import { useErrorBoundary } from 'react-error-boundary'

export interface FollowedLeadDetailsFeesAcceptedProps {
  loggedInPlace: Place,
  currentLead: Lead,
}

const FollowedLeadDetailsFeesAccepted = (props: FollowedLeadDetailsFeesAcceptedProps) => {

  const navigate = useNavigate();
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  console.log("je suis dans le FollowedLeadDetailsFeesAccepted");

  const stopFollowing = async () => {
    try {
      await placesApi.unfollowLead(props.loggedInPlace.id, props.currentLead.id);
      navigate('/places/available-leads');
    } catch (error: any) {
      const newError = new Error(`Une erreur s'est produite : '${error.message}'`);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    }
  };


  const backToFollowedLeads = async () => {
    navigate('/places/available-leads');
  };

  const signLead = async () => {
    try {
      await placesApi.signLead(props.loggedInPlace.id, props.currentLead.id);
      navigate('/places/leads/to-close');
    } catch (error: any) {
      const newError = new Error(`Une erreur s'est produite : '${error.message}'`);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    }
  };

  const [confirmingSignature, setConfirmingSignature] = useState(false);

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
        </ul>
      </div>
       
      <LeadContent lead={props.currentLead} />

      <div className="text-center">
        <div className="text-center btn-list">
          {props.currentLead.status === 'signed' &&
            <div>Ce brief est en cours de signature par un autre lieu</div>
          } 
          {(props.currentLead.status === 'available' || props.currentLead.status === 'followed') &&
          <>
            <span className="position-instructions row mb-3">"Vous souhaitez vous positionner sur ce brief ? Cliquez sur « Me positionner ». Vous verrez apparaitre les coordonnées du client. Nous comptons sur vous pour le contacter sous 24 à 48h. N’oubliez pas de « laisser votre place » si celui-ci ne donne pas suite à votre proposition afin qu’un autre lieu puisse se positionner !
            Si vous contractualisez avec le client, cliquez sur « J’ai signé » "</span>
            <button className="btn btn-primary m-3 return-to-briefs-btn" onClick={backToFollowedLeads}>Retour aux briefs</button> 
            {!confirmingSignature ? (
              <button className="btn btn-primary m-3" onClick={() => setConfirmingSignature(true)}>
                J'ai signé
              </button>
            ) : (
              <button className="btn btn-danger m-3" onClick={signLead}>
                Confirmer la signature
              </button>
            )}
            <button className="btn m-3 stop-follow-btn" onClick={stopFollowing}>Laisser ma place</button>
          </>
          }
        </div>
      </div>
    </div>
  );

}


export default FollowedLeadDetailsFeesAccepted;
